/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import store from './store/store';
import Home from "./views/page-edit/Home";
import AboutUs from "./views/page-edit/AboutUs";
import Contact from "./views/Contact";
import FileUpload from "./views/FileUpload";
import ShippingRules from "./views/ShippingRules";
import Dashboard from "./views/Dashboard";
import DiscountRules from "./views/DiscountRules";
import General from "./views/page-edit/General";
import PaymentMethods from "./views/PaymentMethods";
import Catalogus from "@/views/page-edit/Catalogus";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            meta: {
                requiresAuth: true
            },
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    name: 'dashboard',
                    meta: {
                        title: "Dashboard"
                    },
                    component: Dashboard
                },
                {
                    path: '/contact',
                    name: 'contact',
                    meta: {
                        title: "Contact gegevens"
                    },
                    component: Contact
                },
                {
                    path: '/home-editor',
                    name: 'home-editor',
                    meta: {
                        title: "Home pagina"
                    },
                    component: Home
                },
                {
                    path: '/about-us-editor',
                    name: 'about-us-editor',
                    meta: {
                        title: "Over Gastro-Inox"
                    },
                    component: AboutUs
                },
              {
                path: '/catalogus-editor',
                name: 'catalogus-editor',
                meta: {
                  title: "Catalogus Gastro-Inox"
                },
                component: Catalogus
              },
                {
                    path: '/general-editor/:id',
                    name: 'general-editor',
                    meta: {
                        title: "Pagina editor"
                    },
                    component: General
                },
                {
                    path: '/discount-rules',
                    name: 'discount-rules',
                    meta: {
                        title: "Kortingen"
                    },
                    component: DiscountRules
                },
                {
                    path: '/payment-methods',
                    name: 'payment-methods',
                    meta: {
                        title: "Payment Methods"
                    },
                    component: PaymentMethods
                },
                {
                    path: '/file-upload',
                    name: 'file-upload',
                    meta: {
                        title: "Bestanden uploaden"
                    },
                    component: FileUpload
                },
                {
                    path: '/shipping',
                    name: 'shipping',
                    meta: {
                        title: "Verzendkosten"
                    },
                    component: ShippingRules
                },

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/error-404',
                name: 'error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
})
router.beforeEach((to, from, next) => {
    console.log(to);
    if(to.matched.some(record => record.meta.requiresAuth)) {
        store.dispatch("auth/_loggedIn").then(()=>{
            next();
        }).catch(()=>{
            console.log("not logged in");
            next({
                path: '/login',
            })
        });
    }
    else {
        console.log("guest");
        next()
    }
});
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
